export const API_URL = process.env.REACT_APP_API_URL + "/public";
export const APP_NAME = "ASTAR SYSTEM";
export const IMG_PREFIX_URL = process.env.REACT_APP_IMG_PREFIX_URL;
export const ROWS_PER_PAGE = 16;

export const mobileQuery = "(max-width: 1079px)";
export const tabletQuery = "(min-width: 1080px)";
